import { ReportsStudent } from './reports-student-component'

export default ReportsStudent
export * from './reports-student-component'
